__turbopack_context__.v({
  "loading-indicator-infinite-progress": "LoadingIndicator-module-scss-module__0S7CRa__loading-indicator-infinite-progress",
  "loadingIndicator": "LoadingIndicator-module-scss-module__0S7CRa__loadingIndicator",
  "progress": "LoadingIndicator-module-scss-module__0S7CRa__progress",
});
